import React from 'react'
import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'

import { H2, P } from '@mxenabled/mxui'

import { ConnectDrawer, useAppConfig, useGlobalCopyStore, useScreenSize } from '../common'

import AddAccounts from '../common/components/addaccounts/AddAccounts'
import { GlobalAccountFilter } from '../common/components/GlobalAccountFilter'

const Greeting = () => {
  const [showConnectWidget, setShowConnectWidget] = React.useState(false)

  const { common: commonCopy, connect: connectCopy } = useGlobalCopyStore()
  const { config } = useAppConfig()
  const { isMobile } = useScreenSize()

  const getGreeting = () => {
    const now = new Date()
    const hour = now.getHours()

    if (hour > 1 && hour < 12) {
      return commonCopy.good_morning
    } else if (hour >= 12 && hour < 18) {
      return commonCopy.good_afternoon
    } else {
      return commonCopy.good_evening
    }
  }

  return (
    <React.Fragment>
      <Paper sx={{ gap: 12, mb: isMobile ? 24 : 0, p: 24 }}>
        <Stack alignItems="center" flexDirection="row" justifyContent="space-between">
          <Stack>
            <H2 variant="h3">{getGreeting()}</H2>
            <P color="text.secondary">{commonCopy.heres_your_spending_overview}</P>
          </Stack>
          <Stack flexDirection="row">
            {config.show_connections_widget_in_master && (
              <AddAccounts handleConnectClick={() => setShowConnectWidget(true)} />
            )}
            <GlobalAccountFilter />
          </Stack>
        </Stack>
      </Paper>
      {showConnectWidget && (
        <ConnectDrawer
          onClose={() => setShowConnectWidget(false)}
          showConnectWidget={showConnectWidget}
          title={connectCopy.mini_title}
        />
      )}
    </React.Fragment>
  )
}

export default observer(Greeting)
